import { createAuthConfig, createLoggerConfig, createLoginRequest } from './modules/Auth';
import { DefaultEventHandler, EventHandlers } from './modules/Auth/utils/handleEvents';

const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const REDIRECT_URL = import.meta.env.VITE_REDIRECT_URL;
const KNOWN_AUTHORITY = import.meta.env.VITE_KNOWN_AUTHORITY;
const AUTHORITY_URL = import.meta.env.VITE_AUTHORITY_URL;
const MMP_API_SCOPE = import.meta.env.VITE_MMP_API_SCOPE;

export const SCOPES = [import.meta.env.VITE_CLIENT_ID, 'openid', 'offline_access'];

export const loginRequest = createLoginRequest(SCOPES);

export const authEventHandlers: EventHandlers<DefaultEventHandler> = {
  DEFAULT: (event, payload) => {
    console.log(`default`, event, payload);
  },
  LOGIN_SUCCESS: (event, payload) => {
    console.log('loginSuccess');
  },
  ACQUIRE_TOKEN_SUCCESS: (event, payload) => {
    console.log('acquireTokenSuccess');
  },
  SSO_SILENT_SUCCESS: (event, payload) => {
    console.log('ssoSilentSuccess');
  },
  ACQUIRE_TOKEN_FAILURE: (event, payload) => {
    console.log('acquireTokenFailure');
  },
  ACQUIRE_TOKEN_BY_CODE_FAILURE: (event, payload) => {
    console.log('acquireTokenByCodeFailure');
  },
  SSO_SILENT_FAILURE: (event, payload) => {
    console.log('ssoSilentFailure');
  },
  LOGIN_FAILURE: (event, payload) => {
    console.log('loginFailure');
  },
};

export const authConfig = {
  ...createAuthConfig({
    clientId: CLIENT_ID,
    authority: AUTHORITY_URL,
    knownAuthorities: [KNOWN_AUTHORITY],
    redirectUri: REDIRECT_URL, // Use current url origin so we can test the staging slot
    postLogoutRedirectUri: REDIRECT_URL, // Use current url origin so we can test the staging slot
  }),
  ...createLoggerConfig({
    loggerCallback: (message, level) => {
      console.log(`[${level}] ${message}`);
    },
  }),
};

export const config = {
  baseUrl: import.meta.env.VITE_SERVER_BASE_URL,
  navigateToLoginRequestUrl: true,
  pageSize: 20,
  dataLimitationPageSize: 50,
  inactivityTimeout: 30 * 60 * 1000,
  promptBeforeIdleTimeout: 5 * 60 * 1000,
};
